<template>
  <div>
    <div class="textArea">
      無料会員登録ありがとうございます。<br>
      ログインするためのパスワードを設定してください。
    </div>

    <section-header heading="2" ja="メールアドレス"/>
    <div class="textArea">{{ mailAddress }}</div>

    <section-header heading="2" ja="パスワードを設定する"/>
    <div class="textArea">英大文字・英小文字・数字をそれぞれ1文字以上含む8文字以上のパスワードを設定してください</div>
    <p-text-field
      class="password1-text-field"
      placeholder="password"
      type="password"
      v-model="password1"
    ></p-text-field>
    <p-text-field
      class="password2-text-field"
      placeholder="password（再入力）"
      type="password"
      v-model="password2"
    ></p-text-field>
    <rule v-if="!validPasswordRule">
      大小英字と数字を含む8文字以上127文字以下で入力してください
    </rule>
    <rule v-if="validPasswordRule && password1 && password1 !== password2">
      入力されたパスワードが一致しません
    </rule>

    <section-header heading="2" ja="ニックネームを設定する（任意）"/>
    <div class="textArea">ひらがな・カタカナ・漢字・英数を使用した10文字以内のニックネームを設定してください</div>
    <p-text-field
      class="nickname-text-field"
      placeholder="ニックネーム"
      v-model="nickname"
      @input="nickname"
    ></p-text-field>
    <rule v-if="validateNickname(nickname) || validEmoji(nickname) || nickname.length > 10">
      10文字以内のひらがな・カタカナ・漢字・英数で入力してください
    </rule>

    <section-header heading="2" ja="誕生月を設定する（任意）"/>
    <div class="textArea">生まれた年と月を選択してください</div>
    <p-select
      :items="birthYears"
      v-model="birthYear"
      @change="validateBirthDate"
    ></p-select>
    <p-select
      :items="birthMonths"
      v-model="birthMonth"
      @change="validateBirthDate"
    ></p-select>
    <rule v-if="!birthYear === birthMonth || birthYear === '未選択' || birthMonth === '未選択'">
      年月両方とも選択してください
    </rule>

    <div class="textArea">プリクラONのご利用にあたり、以下に同意して頂く必要があります</div>
    <label for="agreement" class="checkBox">
      <input type="checkbox" name="agreement" class="checkBox__input" id="agreement" :checked="isChecked" />
      <span class="checkBox__custom" :class="{checkMark: isChecked}" @click="toggleAgree()"></span>
      <span class="checkBox__terms" @click="goTerms()">利用規約</span>
      に同意する
    </label>

    <normal-btn
      :disabled="!validForm || validateNickname(nickname) || validEmoji(nickname) || !isChecked"
      @click="onOK">決定</normal-btn>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue'
import PTextField from "../components/PTextField";
import PSelect from '../components/PSelect.vue'
import NormalBtn from '@/components/NormalBtn.vue'
import Rule from '@/components/Rule.vue'
import Protobuf from '../mixins/protobuf'
import Screen from '../mixins/screen'
import Validator from '../mixins/validator'
import {numbers} from "../assets/js/util";


const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
export default {
  components: { PSelect, PTextField, SectionHeader, NormalBtn, Rule },
  mixins: [ Protobuf, Screen, Validator ],
  data () {
    return {
      modal: false,
      mailAddress: '',
      password1: '',
      password2: '',
      passwordRules: ['大小英字と数字を含む8文字以上127文字以下で入力してください'],
      nickname: '',
      nicknameRules: [],
      birthYear: '未選択',
      birthYears: [],
      birthMonth: '未選択',
      birthMonths: [],
      birthDateRules: [],
      okBtnDisabled: true,
      isChecked: false,
    }
  },
  computed: {
    validPasswordRule() {
      let err = this.validPassword(this.password1)
      if (err !== null) {
        return false
      }
      return true
    },
    validForm() {
      let err = this.validPassword(this.password1)
      if (err !== null) {
        return false
      }
      err = this.samePassword(this.password1, this.password2)
      if (err !== null) {
        return false
      }
      err = this.validNickname(this.nickname)
      if (err !== null) {
        return false
      }
      if (this.birthYear !== '未選択' || this.birthMonth !== '未選択') {
        err = this.validBirthDate(this.birthYear, this.birthMonth)
        if (err !== null) {
          return false
        }
      }
      return true
    },
    passwordRule() {
      return this.passwordRules.length > 0 ? this.passwordRules[0] : ''
    },
    nicknameRule() {
      return this.nicknameRules.length > 0 ? this.nicknameRules[0] : ''
    },
    birthDateRule() {
      return this.birthDateRules.length > 0 ? this.birthDateRules[0] : ''
    },
    year() {
      if (this.birthYear === '未選択') {
        return 0
      }
      const y = this.birthYear.split('年')[0]
      return parseInt(y)
    },
    month() {
      if (this.birthMonth === '未選択') {
        return 0
      }
      const m = this.birthMonth.split('月')[0]
      return parseInt(m)
    }
  },
  methods: {
    validatePassword1() {
        this.passwordRules = []
        const err = this.validPassword(this.password1)
        if (err !== null) {
          this.passwordRules.push(err.message)
          return
        }
      },
      validatePassword2() {
        this.passwordRules = []
      let err = this.validPassword(this.password1)
      if (err !== null) {
        return false
      }
      err = this.samePassword(this.password1, this.password2)
      if (err !== null) {
        return
      }
    },
    validateNickname(nickname) {
      const searchTxt = "[①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡㍻〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼]";
      if(nickname.match(searchTxt)){
        return true;
      } else {
        return false;
      }
    },
    validEmoji(text) {
      const pattern = new RegExp("[^" +
      "\u0020-\u007F" + // Basic Latin
      "\u0370-\u03FF" + // Greek and Coptic
      "\u0400-\u04FF" + // Cyrillic
      "\u2000-\u206F" + // General Punctuation
      "\u2150-\u218F" + // Number Forms
      "\u2190-\u21FF" + // Arrows
      "\u2200-\u22FF" + // Mathematical Operators
      "\u2460-\u24FF" + // Enclosed Alphanumerics
      "\u25A0-\u25FF" + // Geometric Shapes
      "\u2600-\u26FF" + // Miscellaneous Symbols
      "\u2E80-\u2EFF" + // CJK Radicals Supplement
      "\u2F00-\u2FDF" + // Kangxi Radicals
      "\u3000-\u303F" + // CJK Symbols and Punctuation
      "\u3040-\u309F" + // Hiragana
      "\u30A0-\u30FF" + // Katakana
      "\u3200-\u32FF" + // Enclosed CJK Letters and Months
      "\u3300-\u33FF" + // CJK Compatibility
      "\u4E00-\u9FFF" + // CJK Unified Ideographs
      "\uF900-\uFAFF" + // CJK Compatibility Ideographs
      "\uFF00-\uFFEF" + // Halfwidth and Fullwidth Forms
      "]", 'g')
      if(text.match(pattern)){
        return true;
      } else {
        return false;
      }
    },
    validateBirthDate() {
      this.birthDateRules = []
      const err = this.validBirthDate(this.birthYear, this.birthMonth)
      if (err !== null) {
        this.birthDateRules.push(err.message)
      }
    },
    onOK () {
      const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
      const cmdNo = pb.PlayerRegistrationReq.CommandNo.COMMAND_NO
      const message = pb.PlayerRegistrationReq.create({
        authType: pb.PlayerRegistrationReq.AuthType.MAIL_ADDRESS,
        password: this.password1,
        nickname: this.nickname,
        birthYear: this.year,
        birthMonth: this.month,
        validateKey: this.$route.query.validateKey
      })
      const encoded = pb.PlayerRegistrationReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.PlayerRegistrationResp.Status.SUCCESS) {
            this.login(decoded.token, pb.LoginResp.MembershipGrade.FREE, decoded.mailAddress, decoded.playerId)
            this.onAgreeTerms()
          } else {
            this.$_error('Error', { title: 'アカウントで登録', statusCode: 401 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'アカウントで登録', statusCode: 100 })
        })
    },
    login(token, membershipGrade, mailAddress, playerId) {
      // 利用規約画面や新規登録画面関連の情報をSessionStorageから削除
      sessionStorage.removeItem('UserInfoRegisration3')
      sessionStorage.removeItem('termsReferrer')
      sessionStorage.removeItem('termsFullReferrer')

      const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
      const registrationType = pb.LoginResp.RegistrationType.WEB_REGIST
      this.$store.dispatch('logout')
      this.$store.dispatch('savePassword', this.password1)
      this.$store.dispatch('login', { token, membershipGrade, mailAddress, playerId, registrationType })
      this.$router.push('/Tutorial')
    },
    goTerms() {
      this.saveUserInfo()
      this.$router.push("/terms")
    },
    saveUserInfo(){
      const userInfo = {
        nickname: this.nickname,
        birthYear: this.birthYear,
        birthMonth: this.birthMonth
      }
      const UserInfoRegisration3 = JSON.stringify(userInfo)
      sessionStorage.setItem('UserInfoRegisration3', UserInfoRegisration3)
      sessionStorage.setItem('termsReferrer', this.$route.path)
      sessionStorage.setItem('termsFullReferrer', this.$route.fullPath)
    },
    toggleAgree(){
      this.isChecked = !this.isChecked;
    },
    // 利用規約に同意
    onAgreeTerms(){
      localStorage.setItem('isAgreedTerms', false);

      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          const cmdNo2 = pb.PlayerGeneralInformationReq.CommandNo.COMMAND_NO
          const message2 = pb.PlayerGeneralInformationReq.create({
            informationId: 1,
            isSave: true,
            intInformation: decoded.termsOfServiceNo,
          })
          const encoded2 = pb.PlayerGeneralInformationReq.encode(message2).finish()
          this.post(cmdNo2, encoded2).catch(() => {
            this.$_error('Error', { title: 'アカウントで登録', statusCode: 100 })
          })
        })
        .catch(() => {
          this.$_error('Error', { title: 'アカウントで登録', statusCode: 100 })
        })
    },
  },
  mounted () {
    const currentYear = new Date().getFullYear()
    const birthYears = numbers(1900, currentYear).reverse().map(y => y + '年')
    const birthMonths = numbers(1, 12).map(m => m + '月')
    this.birthYears = ['未選択'].concat(birthYears)
    this.birthMonths = ['未選択'].concat(birthMonths)

    window.addEventListener('beforeunload', () => {
      this.saveUserInfo()
    })

    const cmdNo = pb.PlayerValidateKeyCheckReq.CommandNo.COMMAND_NO
    const message = pb.PlayerValidateKeyCheckReq.create({
      validateKey: this.$route.query.validateKey
    })
    const encoded = pb.PlayerValidateKeyCheckReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        if (decoded.status === pb.PlayerValidateKeyCheckResp.Status.SUCCESS) {
          this.mailAddress = decoded.mailAddress

          if(sessionStorage.getItem('UserInfoRegisration3') !== null) {
            const userInfo = JSON.parse(sessionStorage.getItem('UserInfoRegisration3'))
            this.nickname = userInfo.nickname
            this.birthYear = userInfo.birthYear
            this.birthMonth = userInfo.birthMonth
          }

        } else if(decoded.status === pb.PlayerValidateKeyCheckResp.Status.FAILED) {
          this.$_error('Error', { title: 'アカウントで登録', statusCode: 403 })
        } else if(decoded.status === pb.PlayerValidateKeyCheckResp.Status.EXPIRED) {
          this.$_error('Error', { title: 'アカウントで登録', statusCode: 402 })
        }
      })
      .catch(() => {
        this.$_error('Error', { title: 'アカウントで登録', statusCode: 100 })
      })
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  padding: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
.checkBox {
  margin: 30px auto 0;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;

  &__input {
    display: none;
  }

  &__custom {
    margin-right: 10px;
    display: block;
    position: relative;
    border: 1px solid #000;
    border-radius: 30%;
    width: 20px;
    height: 20px;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      width: 7px;
      height: 10px;
      top: 10%;
      left: 33%;
      border: 2px solid #000;
      border-top: none;
      border-left: none;
      transform: rotate(45deg);
      opacity: 0;
    }
  }
  .checkMark {
    &::before {
      content: '';
      opacity: 1;
    }
  }
  &__terms {
    color: #F63C5B;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
